import React, { Component } from "react";
import { connect } from "react-redux";
import PubSub from "pubsub-js";
import moment from "moment";
import { forEachObjIndexed, isEmpty, cond, T } from "ramda";
import "../shared/pubsub-triggers";
import TabFlightsWrapper from "./TabFlightsWrapper";
import FilterFlightsWrapper from "./FilterFlightsWrapper";
import FlightsFoundWrapper from "./FlightsFoundWrapper";
import FlightsHeaderWrapper from "./FlightsHeaderWrapper";
import AlertsWrapper from "./AlertsWrapper";
import ProgressBarWrapper from "./ProgressBarWrapper";
import Checkout from "./Checkout";
import FlightsList from "./FlightsList";
import PriceAlert from "./priceAlert/PriceAlert";
import PriceAlertButtonA from "./priceAlert/PriceAlertButtonA";
import PriceAlertButtonB from "./priceAlert/PriceAlertButtonB";
import {
	refreshOfferTimeout,
	resetOfferTimeout,
	getFlightsFromAirlines,
	unselectFlight
} from "../actions";
import MessageFlightsBar from "./MessageFlightsBar";
import ErrorFlightsBar from "./ErrorFlightsBar";
import ErrorContainerMessage from "./ErrorContainerMessage";
import {
	TRIPTYPE_ONEWAY,
	TRIPTYPE_ROUNDTRIP,
	AIRLINE_SEARCH_FLIGHTS_ERROR
} from "../shared/constants";
import { dateDifference, outputFilteredFlights } from "../shared/utils";
import { getAirport } from "../shared/requests-api";
import { storeSearchDataOutsideForm } from "./searchform/utils/localStorageUtils";
import { CookieTypes, getCookie } from "../shared/cookie";

class SearchWrapper extends Component {
	constructor() {
		super();
		this.state = { showMobileFilters: false, selectedFlightsDone: false, priceAlert: null, canOpenModal: false };
		this.hascount = false;
	}

	componentDidMount() {
		if (this.props.airlinesFetched) {
			this.props.resetOfferTimeout();
			this.props.refreshOfferTimeout();
		}

		const searchParams = this.props.searchParams;
		const todayDay = moment(new Date()).format("YYYY-MM-DD");
    	const daysUntilTrave = dateDifference(todayDay, searchParams.outboundDate, "days");
	
		const gaexp = getCookie("_gaexp", CookieTypes.ANALYTIC);

    	if (gaexp && (gaexp.indexOf("9Y7ZhsfpQ5iQVFeYQr7QIQ") > -1 || gaexp.indexOf("fWIDlAc7Sq21EWkLFk5V5A") > -1)) {
			PubSub.publish('dataLayer', {
				'bluegreen': 'original'
			});
				
			window.hj=window.hj||function(){(hj.q=hj.q||[]).push(arguments)};
			hj('trigger', 'valor-total-a');
		}

		window.addEventListener("keydown", function(event) {
			if (event.code === "KeyO" && event.shiftKey && (event.ctrlKey || event.metaKey)) {
				document.querySelectorAll(".flight-ota .flight-item-information").forEach(el => {
					const ribbon = el.querySelector(".corner-ribbon");

					if (ribbon) {
						el.removeChild(ribbon);
					} else {
						el.insertAdjacentHTML("afterbegin", "<div class='corner-ribbon'></div>");
					}
				});

				event.preventDefault();
			}
		});

		Promise.all([getAirport(searchParams["from"]), getAirport(searchParams["to"])]).then(
			([responseFrom, responseTo]) => {
				if (responseFrom.status === 200 && responseTo.status === 200) {
					storeSearchDataOutsideForm(responseFrom, responseTo, searchParams);
				}

				const fromData = this.getCity(responseFrom, searchParams["from"]);
				const toData = this.getCity(responseTo, searchParams["to"]);

				this.setState({
					priceAlert: {
						city: {
							from: fromData,
							to: toData
						}
					}
				});

				try {
					PubSub.publish("dataLayer", {
						event: "ditoTrack",
						ditoTrack: {
							action: "buscou",
							data: {
								aeroporto_de_origem: searchParams.from,
								aeroporto_de_destino: searchParams.to,
								data_da_ida: searchParams.outboundDate,
								data_da_volta: searchParams.inboundDate ? searchParams.inboundDate : null,
								adultos: searchParams.adults,
								criancas: searchParams.children,
								bebes: searchParams.infants,
								cabine: searchParams.cabin,
								tipo_de_viagem: searchParams.tripType,
								dias_ate_viagem: daysUntilTrave,
								pais_origem: fromData.country,
								pais_destino: toData.country,
								tipo_destino: fromData.country === 'BR' && toData.country === 'BR' ?
									'nacional' : 'internacional'
							}
						}
					});
				} catch (e) {
					console.log("Erro no envio de dados para a DITO.");
				}
			}
    );
    

	}

	componentDidUpdate(prevProps) {
		const { location, selectedFlights, unselectFlight } = this.props;
		const { location: prevLocation, history: prevHistory } = prevProps;

		const cameFromCheckoutByBrowserBtn =
			prevLocation.hash === "#checkout" && prevHistory.action === "POP" && location.hash === "";

		if (cameFromCheckoutByBrowserBtn) {
			const unselectIfHasFlight = cond([
				[isEmpty, () => "No flights in direction"],
				[T, flightArray => flightArray.forEach(flight => unselectFlight(flight))]
			]);
			forEachObjIndexed(unselectIfHasFlight, selectedFlights);
		}
	}

	getCity(response, iata) {
		if (Array.isArray(response.data) && response.data.length) {
			const airports = response.data.filter(airport => {
				return airport.iata === iata;
			});

			if (airports.length && airports[0].city !== undefined) {
				return airports[0];
			}
		}

		return {};
	}

	componentWillReceiveProps(props) {
		if (this.hascount == false) {
			if (props.airlinesFetched && props.searchStatus.isInternational >= 0) {
				const flights = outputFilteredFlights(props.flightsFound, undefined, {
					column: "showPrice",
					order: "ORDER_ASC"
				});
				const bestFlight = flights[0];
				const searchParams = props.searchParams;
				const searchStatus = props.searchStatus;

				const todayDay = moment(new Date()).format("YYYY-MM-DD");
				const daysUntilTrave = dateDifference(todayDay, searchParams.outboundDate, "days");

				try {
					PubSub.publish("dataLayer", {
						event: "ditoTrack",
						ditoTrack: {
							action: "acessou-resultados-busca",
							data: {
								mb_cia: bestFlight.airline,
								mb_aeroporto_de_origem: bestFlight.from,
								mb_aeroporto_de_destino: bestFlight.to,
								mb_data_da_ida: searchParams.outboundDate,
								mb_data_da_volta: searchParams.inboundDate ? searchParams.inboundDate : null,
								mb_dias_ate_viagem: daysUntilTrave,
								mb_tipo_destino:
									props.searchStatus && props.searchStatus.isInternational
										? "Internacional"
										: "Nacional",
								mb_pais_origem: searchStatus.fromCountry,
								mb_pais_destino: searchStatus.toCountry,
								mb_preco: bestFlight.showPrice,
								mb_qtd_milhas:
									bestFlight.pricing &&
									bestFlight.pricing.miles &&
									bestFlight.pricing.miles.milesTotal
							}
						}
					});
				} catch (e) {
					console.log("Erro no envio de dados para a DITO.");
				}
				this.hascount = true;
			}
		}
	}

	shouldRenderCheckoutComponent() {
		if (window.location.hash == "#checkout") {
			if (this.props.searchParams.tripType == TRIPTYPE_ONEWAY) {
				return this.props.selectedFlights.outbound.length > 0;
			}

			if (this.props.searchParams.tripType == TRIPTYPE_ROUNDTRIP) {
				return (
					this.props.selectedFlights.outbound.length > 0 &&
					this.props.selectedFlights.outbound.length > 0
				);
			}
		}
	}

	airportsWithErrorResearch() {
		if (this.props.searchStatus.airlines) {
			let airlinesWithError = 0;
			this.props.searchStatus.airlines.forEach(airline => {
				airline.fetchStatus === AIRLINE_SEARCH_FLIGHTS_ERROR ? (airlinesWithError += 1) : null;
			});

			if (airlinesWithError > 0) {
				return (
					<div className="alert alert-danger">
						<div className="alert--icon">
							<i className="icon-close" />
						</div>
						<div className="alert--message">
							<p>
								Ops! Não conseguimos retornar voos de algumas companhias. Mas fique tranquilo, basta
								realizar a busca para tentar novamente!
							</p>
						</div>
					</div>
				);
			}
		}

		return null;
	}

	handleOpenAlertModal = e => {
		e.preventDefault();
		this.setState({  canOpenModal: true })
	}
	handleCloseModal = () => {
		this.setState({  canOpenModal: false })
	}

	render() {
		const { canOpenModal } = this.state;

		if (this.shouldRenderCheckoutComponent()) {
			return <Checkout />;
		}

		if (this.props.searchFlightsStatus === undefined) {
			return (
				<ErrorContainerMessage
					errorType="no-flights"
					button="false"
					title="Ah não!"
					subtitle="Estamos com problemas na nossa busca"
					text="Em breve voltaremos a funcionar normalmente e você
									poderá encontrar passagens aéreas com desconto sem
									precisar ter milhas."
				/>
			);
		}

		switch (this.props.searchFlightsStatus.status) {
			case 422:
				return (
					<div className="searchpage">
						<section className="container-fluid">
							<ErrorFlightsBar typeError={this.props.searchFlightsStatus.data.type} />
						</section>
					</div>
				);

			case 500:
				return (
					<ErrorContainerMessage
						errorType="no-flights"
						button="false"
						title="Ah não!"
						subtitle="Estamos com problemas na nossa busca"
						text="Em breve voltaremos a funcionar normalmente e você
                                        poderá encontrar passagens aéreas com desconto sem
                                        precisar ter milhas."
					/>
				);

			case 200:
				if (
					(this.props.searchStatus.airlines !== undefined &&
						this.props.searchStatus.airlines.length == 0) ||
					(this.props.airlinesFetched && this.props.flightsFound.length == 0)
				) {
					if (this.props.searchStatus.message) {
						return (
							<ErrorContainerMessage
								errorType="500"
								button="true"
								title="Ah não!"
								subtitle="Não temos voos disponíveis para sua busca"
								text={this.props.searchStatus.message}
							/>
						);
					} else {
						if (this.props.searchStatus.isInternational) {
							return (
								<ErrorContainerMessage
									errorType="500"
									button="true"
									title="Ops!"
									subtitle="Não encontramos nenhuma opção de voo para o trecho que você procura"
									text="Por favor, envie um e-mail com todas as informações da passagem para internacional@maxmilhas.com.br que te enviaremos um orçamento por lá, combinado?"
								/>
							);
						} else {
							return (
								<ErrorContainerMessage
									errorType="500"
									button="true"
									title="Ah não!"
									subtitle="Não temos voos disponíveis para sua busca"
									text="Selecione outra origem, destino ou data e tente novamente.
						Só não vale deixar de viajar ;)"
								/>
							);
						}
					}
				} else {
					return (
						<div className="searchpage">
							<PriceAlert {...this.state.priceAlert} canOpenModal={canOpenModal} onClose={this.handleCloseModal} />
							<ProgressBarWrapper />
							<section className="container-fluid">
								<div className="general-info">
									<FlightsFoundWrapper />
									<div className="priceAlertButtonB">
										{ this.props.airlinesFetched && <PriceAlertButtonB onClick={this.handleOpenAlertModal} /> }
									</div>
								</div>
								<MessageFlightsBar />
								<div className="row">
									<div className="col-xs-16 col-md-4">
										<FilterFlightsWrapper />
										<div className="priceAlertButtonA hide">
											{ this.props.airlinesFetched && <PriceAlertButtonA onClick={this.handleOpenAlertModal} /> }										
										</div>
									</div>
									<div className="col-xs-16 col-md-12">
										{this.airportsWithErrorResearch()}
										<div className="flights-wrapper">
											<TabFlightsWrapper />
											<FlightsHeaderWrapper />
											<AlertsWrapper />
											<FlightsList />
										</div>
									</div>
								</div>
							</section>
							<div
								className={
									this.state.showMobileFilters
										? "filter-overlay-wrapper hidden-md hidden-lg filter-overlay-wrapper-show"
										: "filter-overlay-wrapper"
								}
							>
								<div className="filter-header">
									<a
										onClick={e => {
											this.setState(prevState => ({
												showMobileFilters: !prevState.showMobileFilters
											}));
										}}
										title="Fechar"
										className="filter-close"
									>
										<i className="icon-close" />
									</a>
								</div>
								<div className="filter-content">
									<FilterFlightsWrapper showMobileFilters={this.state.showMobileFilters} />
									<a
										onClick={e => {
											this.setState({ showMobileFilters: false });
										}}
										title="Aplicar filtros"
										className="btn btn-success"
									>
										Aplicar Filtros
									</a>
								</div>
							</div>
							<div className="search-tools visible-xs visible-sm">
								<div className="search-tools-wrapper">
									<a
										onClick={e => {
											this.setState(prevState => ({
												showMobileFilters: !prevState.showMobileFilters
											}));
										}}
										className="show-filter"
									>
										<i className="icon-filter" />Filtrar voos
									</a>
								</div>
							</div>
						</div>
					);
				}
		}
	}
}

const mapStateToProps = state => ({
	selectedFlights: state.selectedFlights,
	airlinesFetched: state.searchStatus.progress == 100,
	searchStatus: state.searchStatus,
	searchFlightsStatus: state.searchStatus.response,
	searchParams: state.searchParams.params,
	flightsFound: state.flights.inbound.concat(state.flights.outbound)
});

const mapDispatchToProps = dispatch => ({
	refreshOfferTimeout: () => dispatch(refreshOfferTimeout()),
	resetOfferTimeout: () => dispatch(resetOfferTimeout()),
	getFlightsFromAirlines: flightSearchData =>
		getFlightsFromAirlines(flightSearchData, true, dispatch),
	unselectFlight: flightdata => {
		dispatch(unselectFlight(flightdata));
	}
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchWrapper);
